import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const CrownIcon = createIcon({
  displayName: 'CrownIcon',
  path: [
    <path
      d='M2.83984 8.57604L5.20296 16.9201H19.1098L20.9919 8.57604C17.7923 12.9677 14.8855 12.9886 12.0205 6.1711C9.53186 12.9677 6.68775 12.8004 2.83984 8.57604Z'
      fill='#FFF780'
    />,
    <path
      d='M12.0215 16.9202H16.3713H19.1108L20.993 8.57605C17.7933 12.9677 14.8865 12.9886 12.0215 6.17111C12.0216 13.1977 12.0215 13.0304 12.0215 16.9202Z'
      fill='#FFC02E'
    />,
    <circle cx='11.9998' cy='7.00759' r='2.0076' fill='#FFC02E' />,
    <path
      d='M12.0002 9.01519C12.5327 9.01519 13.0433 8.80368 13.4198 8.42718C13.7963 8.05068 14.0078 7.54004 14.0078 7.00759C14.0078 6.47514 13.7963 5.9645 13.4198 5.588C13.0433 5.2115 12.5327 4.99998 12.0002 4.99998L12.0002 7.00759L12.0002 9.01519Z'
      fill='#FFA73B'
    />,
    <rect
      x='4.63867'
      y='16.4182'
      width='14.7643'
      height='2.50951'
      rx='0.585551'
      fill='#FFC02E'
    />,
    <path
      d='M12.041 16.4183H18.8376C19.161 16.4183 19.4231 16.6804 19.4231 17.0038V18.3422C19.4231 18.6656 19.161 18.9278 18.8376 18.9278H12.041V16.4183Z'
      fill='#FFA73B'
    />,
    <circle cx='3.0076' cy='8.84789' r='2.0076' fill='#FFC02E' />,
    <circle cx='20.992' cy='8.84789' r='2.0076' fill='#FFA73B' />
  ],
  defaultProps: defaultProps
})
